export default import.meta.ROLLDOWN_FILE_URL_Yar98uEqsg4j$dzO2S0ufw